export class Prod {
	constructor() {}

	async sendSert(parent) {
		let form = $(parent)
		let card = form.find("input[name='str_card']").val()
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=29",
			type: "POST",
			data: {
				action: "reg_sert",
				card: card,
			},
			dataType: "json",
			success: function(res) {
				console.log("Ответ от сервера:", res)
				if (res.success) {
					$("#send_sert_res")
						.removeClass("reg-prod__sert-error")
						.addClass("reg-prod__sert-success")
						.fadeIn()
						.text("Спасибо, номер принят!")
					if (res.Authorization) {
						_this.gotoStep(2) // Переход к rstep_2
					} else {
						_this.gotoStep(1) // Переход к rstep_1
					}
				} else {
					if (res.error === "not_authenticated") {
						_this.showLoginForm(card)
					} else {
						$("#send_sert_res")
							.removeClass("reg-prod__sert-success")
							.addClass("reg-prod__sert-error")
							.fadeIn()
							.text(res.error)
					}
				}
			},
			error: function(e) {
				console.log(e)
			},
		})
	}

	showLoginForm(card) {
		// Скрываем текущую форму ввода кода
		$(".reg-prod__sert.reg_step:visible").fadeOut(() => {
			// Отображаем форму авторизации/регистрации
			$(".reg-prod__main.reg_step#rstep_1").fadeIn()
		})

		localStorage.setItem("card", card)
	}

	gotoStep(num) {
		$(".reg_step:visible").fadeOut()
		$(".reg_step#rstep_" + num).fadeIn()
	}

	sendAuth(parent) {
		let form = $(parent)
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=12",
			type: "POST",
			data: form.serialize(),
			dataType: "json",
			success: function(res) {
				if (res.success) {
					_this.gotoStep(2)
					$(".header-panel__authorization").replaceWith(res["auth_block"])

					let card = localStorage.getItem("card")
					_this.sendSertCard(card)
				} else {
					swal("Ошибка: " + res["error"])
					if (res["activate_link"]) {
						swal(
							"Ошибка: " + res["error"],
							'<a href="' +
								res["activate_link"] +
								'" target="_blank">Выслать код активации повторно</a>'
						)
					}
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	sendSertCard(card) {
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=29",
			type: "POST",
			data: {
				action: "reg_sert",
				card: card,
			},
			dataType: "json",
			success: function(res) {
				console.log("Ответ от сервера:", res)
				if (res.success) {
					$("#send_sert_res")
						.removeClass("reg-prod__sert-error")
						.addClass("reg-prod__sert-success")
						.fadeIn()
						.text("Спасибо, номер принят!")
					_this.gotoStep(2) // Переход к rstep_2
				} else {
					$("#send_sert_res")
						.removeClass("reg-prod__sert-success")
						.addClass("reg-prod__sert-error")
						.fadeIn()
						.text(res.error)
				}
			},
			error: function(e) {
				console.log(e)
			},
		})
	}

	sendReg(parent) {
		let form = $(parent)
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=25",
			type: "POST",
			data: form.serialize(),
			dataType: "json",
			success: function(res) {
				if (res.status == "success") {
					_this.gotoStep(2)
					$(".header-panel__authorization").replaceWith(res["auth_block"])
				} else {
					swal("Ошибка: " + res["message"])
					if (res["restore"]) {
						swal(
							"Ошибка: " + res["message"],
							'<a href="#">Напомнить пароль</a>'
						)
					}
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	remindPass(parent) {
		let form = $(parent)
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=12",
			type: "POST",
			data: form.serialize() + "&action=remind_pass",
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					form.find(".popup-typical__form-container").hide()

					form
						.find(".popup-typical__form-error")
						.text("")
						.fadeOut()
					form
						.find(".popup-typical__form-success")
						.text("Новый пароль отправлен на Ваш e-mail")
						.fadeIn()

					form.find('button.popup-typical__btn[type="submit"]').hide()
				} else {
					form
						.find(".popup-typical__form-error")
						.text(res["error"])
						.fadeIn()
					form
						.find(".popup-typical__form-success")
						.text("")
						.fadeOut()

					if (res["restore"]) {
					}
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}

	sendTopics(parent) {
		let form = $(parent)
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=29",
			type: "POST",
			data: form.serialize() + "&action=reg_topics",
			dataType: "json",
			success: function(res) {
				if (res.success) {
					_this.gotoStep(2) // Переход к rstep_3
				} else {
					console.log(res.error)
				}
			},
			error: function(e) {
				console.log(e)
			},
		})
	}

	getMet(parent) {
		let form = $(parent)
		let _this = this

		$.ajax({
			url: "/ajax.php?mid=25",
			type: "POST",
			data: form.serialize() + "&action=get_metodic",
			dataType: "json",
			success: function(res) {
				if (res.success) {
					$(".reg-prod__instructions-number-main a").attr("href", res.link)
					$(".reg-prod__instructions-number-main a").fadeIn()
				} else {
					swal("Ошибка", res.error)
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	}
}
